import { api } from "api/api";
import { AxiosError } from "axios";
import Representante from "model/fiscal/Representante";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class RepresentanteService implements BaseServiceCadastros<Representante> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/representante/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Representante>((resolve, reject): void => {
            api
                .get(`/representante/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(representante: Representante) {
        return new Promise<Representante>((resolve, reject): void => {
            api
                .post(`/representante/incluir`, JSON.stringify(representante))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(representante: Representante) {
        return new Promise<Representante>((resolve, reject): void => {
            api
                .put(`/representante/editar`, JSON.stringify(representante))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/representante/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getListaTipoPessoa() {
        return [
            { value: "FISICA", label: "Pessoa física" },
            { value: "JURIDICA", label: "Pessoa jurídica" }
        ];
    }

    getTipoPessoa(tipoPessoa: string) {
        return this.getListaTipoPessoa().find(item => item.value === tipoPessoa)?.label || "";
    }

}
export default RepresentanteService;
